export const fruits = [
  { key: "love", label: "Love", prompt: "Where did love move from intention into action?" },
  { key: "joy", label: "Joy", prompt: "What moment invited quiet gratitude?" },
  { key: "peace", label: "Peace", prompt: "Where did you notice steadiness instead of striving?" },
  { key: "patience", label: "Patience", prompt: "When were you invited to wait with grace?" },
  { key: "kindness", label: "Kindness", prompt: "Who received gentleness through your words or presence?" },
  { key: "goodness", label: "Goodness", prompt: "What good choice felt costly but right?" },
  { key: "faithfulness", label: "Faithfulness", prompt: "Where did you remain steady in what matters?" },
  { key: "gentleness", label: "Gentleness", prompt: "Where did softness create room for healing?" },
  { key: "self_control", label: "Self-control", prompt: "What desire did you wisely reorder today?" },
];

export const emptyRatings = fruits.reduce((acc, fruit) => ({ ...acc, [fruit.key]: 3 }), {});

export const fruitLabel = (key) => fruits.find((fruit) => fruit.key === key)?.label || key;

export const scaleGuide = [
  { score: 1, label: "Needs prayerful attention" },
  { score: 2, label: "Beginning to notice" },
  { score: 3, label: "Growing with grace" },
  { score: 4, label: "Often evident" },
  { score: 5, label: "Strongly evident this season" },
];